import React from "react";

const CardRowSegmentHeader = (props: React.PropsWithChildren<unknown>) => {
  return <div className="text-sublabel">
    {props.children}
  </div >;
};

export default CardRowSegmentHeader;